import cn from 'classnames'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, PropsWithChildren, useRef } from 'react'
import { useDrop } from 'react-dnd'

import { changeItemGroup } from 'partner360/features/assortment/assortmentSlice'

import { DRAG_ASSORTIMENT_ITEM_KEY } from '../../configs'
import { IDraggableAssortmentItem } from '../../models/assortmentDnd'

import styles from './GroupContent.module.scss'

interface IGroupContentProps extends PropsWithChildren {
  groupId: number
}

export const GroupContent: FC<IGroupContentProps> = ({ groupId, children }) => {
  const dispatch = useAppDispatch()
  const dropRef = useRef<HTMLDivElement>(null)

  const [{ isOver }, drop] = useDrop({
    accept: DRAG_ASSORTIMENT_ITEM_KEY,

    collect: (monitor) => {
      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }
    },

    hover: (draggedItem: IDraggableAssortmentItem) => {
      if (draggedItem.groupId !== groupId) {
        dispatch(
          changeItemGroup({
            itemId: draggedItem.itemId,
            newGroupId: groupId,
          })
        )
      }
    },
  })

  drop(dropRef)

  return (
    <div
      className={cn(styles.root, {
        [styles.empty]: isOver,
      })}
      ref={dropRef}
    >
      {children}
    </div>
  )
}
